/**
 * useDeleteRitualImage Hook
 * Mutation hook for deleting ritual images
 */

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"
import { deleteRitualImage } from "../services/ritual.service"

interface DeleteRitualImageVariables {
  ritualId: string
  uploadId: string
}

export function useDeleteRitualImage() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ ritualId, uploadId }: DeleteRitualImageVariables) =>
      deleteRitualImage(ritualId, uploadId),

    onSuccess: () => {
      // Invalidate ritual query to refetch
      queryClient.invalidateQueries({
        queryKey: ["ritual"],
      })
      toast.success("Image deleted successfully")
    },

    onError: () => {
      toast.error("Failed to delete image")
    },
  })
}
